(() => {
  if (customElements.get('cfa-kit-builder')) return;
  class CfaKitBuilder extends HTMLElement {
    connectedCallback() {
      this.formEvents = new AbortController();
      document.addEventListener('input', event => {
        if (event.target.name === 'quantity' && event.target.form === this.mainForm()) this.updateTotal();
      }, {signal:this.formEvents.signal});
      document.addEventListener('change', event => {
        if (event.target.name === 'quantity' && event.target.form === this.mainForm()) this.updateTotal();
      }, {signal:this.formEvents.signal});
      if (this.initialised) { this.updateTotal(); return; }
      this.initialised = true;
      this.busy = false;
      this.addEventListener('change', () => this.updateTotal());
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-kit-add]');
        if (button && this.contains(button)) this.addItems(button.dataset.kitAdd);
      });
      this.updateTotal();
    }
    disconnectedCallback() { this.formEvents?.abort(); }
    selectedItems() {
      return [...this.querySelectorAll('.cfa-kit-item')].filter(row => row.querySelector('[data-kit-check]').checked);
    }
    mainForm() {
      const rerender = this.closest('product-rerender');
      return rerender ? document.getElementById(rerender.getAttribute('observe-form')) : null;
    }
    root() { return (this.dataset.root || '/').replace(/\/?$/, '/'); }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency || 'AUD'}).format(cents / 100); }
    updateTotal() {
      const rows = this.selectedItems();
      const complete = rows.every(row => row.querySelector('[data-kit-variant]').value);
      const total = rows.reduce((sum, row) => sum + Number(row.querySelector('[data-kit-variant]').selectedOptions[0]?.dataset.price || 0), 0);
      const form = this.mainForm();
      const quantity = form ? Number(new FormData(form).get('quantity') || 1) : 1;
      this.querySelector('.cfa-kit-total').textContent = !rows.length ? '' : complete ? `Selected extras: ${this.money(total)}${this.dataset.anchorAllowed === 'true' && form ? ' · With this product: ' + this.money(total + Number(this.dataset.price) * quantity) : ''}. Each extra is added once.` : 'Choose an option for each selected extra.';
      this.querySelector('.cfa-kit-actions').hidden = !rows.length;
      this.querySelectorAll('[data-kit-add]').forEach(button => { button.disabled = this.busy || !rows.length || !complete; });
    }
    async addItems(mode) {
      if (this.busy) return;
      const rows = this.selectedItems();
      if (!rows.length || rows.some(row => !row.querySelector('[data-kit-variant]').value)) return;
      const items = rows.map(row => ({id:Number(row.querySelector('[data-kit-variant]').value),quantity:1}));
      const form = this.mainForm();
      if (mode === 'with-product') {
        if (this.dataset.anchorAllowed !== 'true' || !form || !form.reportValidity()) return;
        const data = new FormData(form);
        const id = Number(data.get('id'));
        const quantity = Number(data.get('quantity') || 1);
        if (!id || !Number.isInteger(quantity) || quantity < 1) return;
        const anchor = {id,quantity};
        const properties = {};
        for (const [name,value] of data.entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) anchor.properties = properties;
        if (data.get('selling_plan')) anchor.selling_plan = data.get('selling_plan');
        items.unshift(anchor);
      }
      this.busy = true;
      this.updateTotal();
      const status = this.querySelector('.cfa-kit-status');
      status.textContent = 'Adding your selection…';
      try {
        const response = await fetch(this.root() + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Your selection could not be fully added.');
        status.textContent = 'Added. Opening your cart…';
        document.dispatchEvent(new CustomEvent('cfa:kit-added',{detail:{productId:this.dataset.productId,mode,itemCount:items.length}}));
        window.location.assign(this.root() + 'cart');
      } catch (error) {
        // Shopify may partially add stock on 422; a lost response is also uncertain.
        // Keep actions disabled so a repeated click cannot silently duplicate items.
        status.textContent = `${error.message || 'Unable to confirm your selection.'} Review your cart before adding again.`;
        this.querySelector('[data-kit-cart]').hidden = false;
      }
    }
  }
  customElements.define('cfa-kit-builder', CfaKitBuilder);
})();
